
















import NoteModal from "./NoteModal.vue";
import { NoteApi } from "../api/NoteApi";

export default {
    name: "JournalNoteButton",
    components: { NoteModal },
    data() {
        return {
            showModal: false,
            notesCount: 0,
            NoteApi: new NoteApi(),
        };
    },
    created() {
        let self = this;
        self.NoteApi.getCount().then(function (response) {
            self.notesCount = response;
        });
    },
    methods: {
        openModal: function () {
            this.showModal = true;
        },
        closeModal: function () {
            this.showModal = false;
        },
    },
};
